// const mainUrl = "http://localhost:5000";
const mainUrl = "https://backend.songoltcargo.mn"

//auth urls
export const org_uri = mainUrl + "/org";
export const loginUri = mainUrl + "/admin";
export const logoutUri = mainUrl + "/org";

export const utils_uri = mainUrl + "/utils";
export const products_uri = mainUrl + "/products";
export const product_uri = mainUrl + "/product";

export const order_uri = mainUrl + "/order";
export const users_uri = mainUrl + "/users";
export const delivery_uri = mainUrl + "/delivery";
export const lesson_uri = mainUrl + "/lesson";
export const baseUrlLink = "https://songoltbucket.s3.ap-southeast-1.amazonaws.com//upload/image-"
